(function () {
  let configs = [];
  let intervalId = null;

  function parseConfig(el) {
    const cp = (el.getAttribute('data-shipping-usp-cutoff') || '21:30').split(':');
    const fp = (el.getAttribute('data-shipping-usp-friday-evening-start') || '21:30').split(':');
    return {
      el,
      textEl: el.querySelector('.shipping-usp-text'),
      cutoffHour: parseInt(cp[0], 10),
      cutoffMinute: parseInt(cp[1] || '0', 10),
      fridayEveningHour: parseInt(fp[0], 10),
      fridayEveningMinute: parseInt(fp[1] || '0', 10),
      sameDayText: el.getAttribute('data-shipping-usp-same-day') || '',
      weekdayAfterText: el.getAttribute('data-shipping-usp-weekday-after') || '',
      mondayText: el.getAttribute('data-shipping-usp-monday') || '',
    };
  }

  function pickText(c, day, hours, minutes) {
    const afterCutoff = hours > c.cutoffHour || (hours === c.cutoffHour && minutes >= c.cutoffMinute);
    const afterFridayEvening = hours > c.fridayEveningHour || (hours === c.fridayEveningHour && minutes >= c.fridayEveningMinute);

    if (day >= 1 && day <= 4) {
      return afterCutoff ? (c.weekdayAfterText || c.sameDayText) : c.sameDayText;
    }
    if (day === 5) {
      if (afterFridayEvening) return c.mondayText || c.sameDayText;
      return afterCutoff ? (c.weekdayAfterText || c.sameDayText) : c.sameDayText;
    }
    return c.mondayText || c.sameDayText;
  }

  function update() {
    if (!configs.length) return;
    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    for (const c of configs) {
      if (!c.textEl || !c.sameDayText) continue;
      const text = pickText(c, day, hours, minutes);
      if (c.textEl.textContent !== text) c.textEl.textContent = text;
    }
  }

  function init() {
    const els = document.querySelectorAll('[data-shipping-usp-cutoff]');
    configs = Array.from(els, parseConfig);
    update();

    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    if (configs.length) intervalId = setInterval(update, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
